import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { useMemo } from 'react';
import { getRatio } from '../utils';
import { getMinPercentageDifference } from '../utils/timeSpentUtils';
import TimeSpentViewingBar from './TimeSpentViewingBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TimeSpentViewingBars({
  openDurationAggregated
}) {
  const total = useMemo(() => openDurationAggregated.glanced + openDurationAggregated.read + openDurationAggregated.skimmed, [openDurationAggregated.glanced, openDurationAggregated.read, openDurationAggregated.skimmed]);
  const isEmptyState = useMemo(() => total === 0, [total]);
  const {
    readPercentage,
    skimmedPercentage,
    glancedPercentage
  } = useMemo(() => ({
    readPercentage: getRatio(openDurationAggregated.read, total),
    skimmedPercentage: getRatio(openDurationAggregated.skimmed, total),
    glancedPercentage: getRatio(openDurationAggregated.glanced, total)
  }), [openDurationAggregated.glanced, openDurationAggregated.read, openDurationAggregated.skimmed, total]);
  const minPercentageDifference = useMemo(() => getMinPercentageDifference(readPercentage, skimmedPercentage, glancedPercentage), [glancedPercentage, readPercentage, skimmedPercentage]);
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    gap: "500",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      gap: "100",
      children: [/*#__PURE__*/_jsx(TimeSpentViewingBar, {
        backgroundColor: isEmptyState ? 'fill-primary-disabled' : 'fill-accent-orange-default',
        isEmptyState: isEmptyState,
        percentage: readPercentage,
        percentageDifference: minPercentageDifference,
        title: I18n.text('frameworkAssetPreviewLib.propertyLabel.0-29.timeSpent.read'),
        tooltip: I18n.text('frameworkAssetPreviewLib.propertyLabel.0-29.timeSpent.readTooltip')
      }), /*#__PURE__*/_jsx(TimeSpentViewingBar, {
        backgroundColor: isEmptyState ? 'fill-primary-disabled' : 'fill-accent-green-default',
        isEmptyState: isEmptyState,
        percentage: skimmedPercentage,
        percentageDifference: minPercentageDifference,
        title: I18n.text('frameworkAssetPreviewLib.propertyLabel.0-29.timeSpent.skimmed'),
        tooltip: I18n.text('frameworkAssetPreviewLib.propertyLabel.0-29.timeSpent.skimmedTooltip')
      }), /*#__PURE__*/_jsx(TimeSpentViewingBar, {
        backgroundColor: isEmptyState ? 'fill-primary-disabled' : 'fill-accent-purple-default',
        isEmptyState: isEmptyState,
        percentage: glancedPercentage,
        percentageDifference: minPercentageDifference,
        title: I18n.text('frameworkAssetPreviewLib.propertyLabel.0-29.timeSpent.glanced'),
        tooltip: I18n.text('frameworkAssetPreviewLib.propertyLabel.0-29.timeSpent.glancedTooltip')
      })]
    })
  });
}